<template>
  <div class="content">
    <ul class="five">
      <li class="five-item" v-for="(item, index) in Overview" :key="index">
        <div class="img-sty">
          <a class="img-hover"><img class="img-wh" :src="item.imagePath" /></a>
        </div>
        <div class="five-mesage">
          <p v-html="item.content" style="font-size:16px;color:#555;"></p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
    export default {
        name: 'First',
        props: {
          Overview: {
            type: Array,
            default: () => ([])
          },
        },
        mounted() {
          console.log(this.Overview, '999');
        },
        methods: {
          // 下载
          goDownload(val){
            window.open(val);
          },
        }
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.five {
  padding: 30px 40px 0 27px;
}
.five-item {
  display:flex;
  justify-content: center;
  margin-bottom:40px;
}
.img-sty {
    width:225px;
    height:225px;
    overflow: hidden;
    max-width:225px;
    max-height:225px;
    border-radius: 3px;
    box-shadow: 2px 2px 2px #fcfcfc;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    width:100%;
    height:auto;
    max-height:141px;
    max-width:100%;
  }
  .five-mesage {
    flex:1;
    padding-left:30px;
  }
</style>